/* eslint-disable */
// Approved list
import structures$RoomView from 'matrix-react-sdk/lib/components/structures/RoomView'
import views$avatars$RoomAvatar from 'matrix-react-sdk/lib/components/views/avatars/RoomAvatar'
import views$elements$AccessibleButton from 'matrix-react-sdk/lib/components/views/elements/AccessibleButton'
import structures$MainSplit from 'matrix-react-sdk/lib/components/structures/MainSplit'
import views$rooms$AuxPanel from 'matrix-react-sdk/lib/components/views/rooms/AuxPanel'
import structures$ScrollPanel from 'matrix-react-sdk/lib/components/structures/ScrollPanel'
import structures$AutoHideScrollbar from 'matrix-react-sdk/lib/components/structures/AutoHideScrollbar'
import views$messages$DateSeparator from 'matrix-react-sdk/lib/components/views/messages/DateSeparator'
import views$elements$ProgressBar from 'matrix-react-sdk/lib/components/views/elements/ProgressBar'
import views$messages$TextualEvent from 'matrix-react-sdk/lib/components/views/messages/TextualEvent'
import views$messages$MessageTimestamp from 'matrix-react-sdk/lib/components/views/messages/MessageTimestamp'
import views$messages$ReactionsRow from 'matrix-react-sdk/lib/components/views/messages/ReactionsRow'
import views$messages$MessageOverlay from 'matrix-react-sdk/lib/components/views/messages/MessageOverlay'
import views$elements$InteractiveTooltip from 'matrix-react-sdk/lib/components/views/elements/InteractiveTooltip'
import views$rooms$MessageComposerFormatBar from 'matrix-react-sdk/lib/components/views/rooms/MessageComposerFormatBar'
import views$rooms$TopUnreadMessagesBar from 'matrix-react-sdk/lib/components/views/rooms/TopUnreadMessagesBar'
import structures$ContextualMenu from 'matrix-react-sdk/lib/components/structures/ContextualMenu'
import views$messages$MFileBody from 'matrix-react-sdk/lib/components/views/messages/MFileBody'
import views$messages$MImageBody from 'matrix-react-sdk/lib/components/views/messages/MImageBody'
import views$messages$MVideoBody from 'matrix-react-sdk/lib/components/views/messages/MVideoBody'
import views$messages$MAudioBody from 'matrix-react-sdk/lib/components/views/messages/MAudioBody'
import views$messages$MFileTypeBody from 'matrix-react-sdk/lib/components/views/messages/MFileTypeBody'
import views$dialogs$BaseDialog from 'matrix-react-sdk/lib/components/views/dialogs/BaseDialog'
import views$rooms$RoomDropTarget from 'matrix-react-sdk/lib/components/views/rooms/RoomDropTarget'
import structures$UploadBar from 'matrix-react-sdk/lib/components/structures/UploadBar'
import views$elements$DialogButtons from 'matrix-react-sdk/lib/components/views/elements/DialogButtons'
import views$elements$ImageView from 'matrix-react-sdk/lib/components/views/elements/ImageView'
import views$context_menus$GenericElementContextMenu from 'matrix-react-sdk/lib/components/views/context_menus/GenericElementContextMenu'
import views$messages$ReactionsRowButton from 'matrix-react-sdk/lib/components/views/messages/ReactionsRowButton'
import views$emojipicker$ReactionPicker from 'matrix-react-sdk/lib/components/views/emojipicker/ReactionPicker'
import views$elements$LazyRenderList from 'matrix-react-sdk/lib/components/views/elements/LazyRenderList'
import views$dialogs$QuestionDialog from 'matrix-react-sdk/lib/components/views/dialogs/QuestionDialog'
import views$context_menus$MessageContextMenu from 'matrix-react-sdk/lib/components/views/context_menus/MessageContextMenu'
import views$dialogs$ConfirmRedactDialog from 'matrix-react-sdk/lib/components/views/dialogs/ConfirmRedactDialog'
import views$dialogs$ConfirmAndWaitRedactDialog from 'matrix-react-sdk/lib/components/views/dialogs/ConfirmAndWaitRedactDialog'
import views$dialogs$UploadFailureDialog from 'matrix-react-sdk/lib/components/views/dialogs/UploadFailureDialog'
import views$dialogs$ErrorDialog from 'matrix-react-sdk/lib/components/views/dialogs/ErrorDialog'
import views$rooms$LinkPreviewWidget from 'matrix-react-sdk/lib/components/views/rooms/LinkPreviewWidget'

import Empty from './Empty'

// Overrides
import views$elements$GeminiScrollbarWrapper from './GeminiScrollbarWrapper'
import views$rooms$BasicMessageComposer from './BasicMessageComposer'
import views$messages$MessageActionBar from './MessageActionBar'
import views$rooms$MessageComposer from './MessageComposer'
import structures$MessagePanel from './MessagePanel'
import views$messages$StateEvent from './Events/StateEvent'
import views$messages$IntegrationEvent from './Events/IntegrationEvent'
import views$messages$IntegrationEventExternal from './Events/IntegrationEvent/External'
import views$rooms$SendMessageComposer from './SendMessageComposer'
import views$avatars$MemberAvatar from './MemberAvatar'
import views$rooms$EventTile from './EventTile'
import views$emojipicker$EmojiPicker from './EmojiPicker'
import views$rooms$EmojiPickerButton from './EmojiPickerButton'
import views$messages$ReactionsRowAddButton from './ReactionsRowAddButton'
import views$rooms$ReplyPreview from './ReplyPreview'
import views$messages$ShadowBody from './ShadowBody'
import views$messages$MessageEvent from './MessageEvent'
import views$messages$TextualBody from './TextualBody'
import views$dialogs$UploadConfirmDialog from './UploadConfirmDialog'
import views$rooms$WhoIsTypingTile from './WhoIsTypingTile'
import views$avatars$BaseAvatar from './BaseAvatar'
import structures$TimelinePanel from './TimelinePanel'
import views$elements$ErrorBoundary from './ErrorBoundary'

const components = {}

components['views.rooms.LinkPreviewWidget'] = views$rooms$LinkPreviewWidget
components['views.dialogs.ErrorDialog'] = views$dialogs$ErrorDialog
components[
  'views.dialogs.UploadFailureDialog'
] = views$dialogs$UploadFailureDialog
components[
  'views.dialogs.ConfirmAndWaitRedactDialog'
] = views$dialogs$ConfirmAndWaitRedactDialog
components[
  'views.dialogs.ConfirmRedactDialog'
] = views$dialogs$ConfirmRedactDialog
components[
  'views.context_menus.MessageContextMenu'
] = views$context_menus$MessageContextMenu
components['views.dialogs.QuestionDialog'] = views$dialogs$QuestionDialog
components['views.avatars.BaseAvatar'] = views$avatars$BaseAvatar
components['views.elements.LazyRenderList'] = views$elements$LazyRenderList
components[
  'views.emojipicker.ReactionPicker'
] = views$emojipicker$ReactionPicker
components['views.emojipicker.EmojiPicker'] = views$emojipicker$EmojiPicker
components[
  'views.messages.ReactionsRowButton'
] = views$messages$ReactionsRowButton

components[
  'views.context_menus.GenericElementContextMenu'
] = views$context_menus$GenericElementContextMenu
components[
  'views.messages.ReactionsRowAddButton'
] = views$messages$ReactionsRowAddButton
components['views.elements.ImageView'] = views$elements$ImageView
components['views.elements.DialogButtons'] = views$elements$DialogButtons

components['structures.UploadBar'] = structures$UploadBar
components['views.rooms.RoomDropTarget'] = views$rooms$RoomDropTarget
components['views.dialogs.BaseDialog'] = views$dialogs$BaseDialog

components[
  'views.dialogs.UploadConfirmDialog'
] = views$dialogs$UploadConfirmDialog
components['views.messages.MFileTypeBody'] = views$messages$MFileTypeBody
components['views.messages.MAudioBody'] = views$messages$MAudioBody
components['views.messages.MVideoBody'] = views$messages$MVideoBody
components['views.messages.MImageBody'] = views$messages$MImageBody
components['views.messages.MFileBody'] = views$messages$MFileBody
components['structures.ContextualMenu'] = structures$ContextualMenu
components['views.messages.MessageEvent'] = views$messages$MessageEvent
components['views.messages.ShadowBody'] = views$messages$ShadowBody
components['views.messages.StateEvent'] = views$messages$StateEvent
components['views.messages.IntegrationEvent'] = views$messages$IntegrationEvent
components[
  'views.messages.IntegrationEventExternal'
] = views$messages$IntegrationEventExternal
components['views.messages.TextualBody'] = views$messages$TextualBody
components['views.messages.MessageOverlay'] = views$messages$MessageOverlay
components[
  'views.rooms.MessageComposerFormatBar'
] = views$rooms$MessageComposerFormatBar
components['views.rooms.ReplyPreview'] = views$rooms$ReplyPreview
components['views.rooms.SendMessageComposer'] = views$rooms$SendMessageComposer
components['views.rooms.WhoIsTypingTile'] = views$rooms$WhoIsTypingTile
components[
  'views.elements.InteractiveTooltip'
] = views$elements$InteractiveTooltip
components['views.messages.ReactionsRow'] = views$messages$ReactionsRow
components['views.messages.MessageTimestamp'] = views$messages$MessageTimestamp
components['views.messages.TextualEvent'] = views$messages$TextualEvent
components['views.rooms.EventTile'] = views$rooms$EventTile
components['views.avatars.MemberAvatar'] = views$avatars$MemberAvatar
components['views.messages.DateSeparator'] = views$messages$DateSeparator
components['structures.AutoHideScrollbar'] = structures$AutoHideScrollbar
components['structures.ScrollPanel'] = structures$ScrollPanel
components['structures.TimelinePanel'] = structures$TimelinePanel
components['views.rooms.AuxPanel'] = views$rooms$AuxPanel
components['structures.MainSplit'] = structures$MainSplit
components['views.elements.AccessibleButton'] = views$elements$AccessibleButton
components['views.avatars.RoomAvatar'] = views$avatars$RoomAvatar
components['views.elements.ErrorBoundary'] = views$elements$ErrorBoundary
components['structures.RoomView'] = structures$RoomView

components[
  'views.elements.GeminiScrollbarWrapper'
] = views$elements$GeminiScrollbarWrapper
components[
  'views.rooms.BasicMessageComposer'
] = views$rooms$BasicMessageComposer
components['views.messages.MessageActionBar'] = views$messages$MessageActionBar
components['views.rooms.MessageComposer'] = views$rooms$MessageComposer
components['structures.MessagePanel'] = structures$MessagePanel
components['views.rooms.EmojiPickerButton'] = views$rooms$EmojiPickerButton
components['views.elements.ProgressBar'] = views$elements$ProgressBar
components[
  'views.rooms.TopUnreadMessagesBar'
] = views$rooms$TopUnreadMessagesBar
components['views.messages.UnknownBody'] = Empty

// Removed
components['views.rooms.JumpToBottomButton'] = Empty
components['views.elements.Dropdown'] = Empty
components['views.elements.IconButton'] = Empty
components['views.elements.ReplyThread'] = Empty
components['views.elements.Tooltip'] = Empty
components['views.emojipicker.recent'] = Empty
components['views.emojipicker.Emoji'] = Empty
components['views.emojipicker.Category'] = Empty
components['views.emojipicker.Search'] = Empty
components['views.emojipicker.Header'] = Empty
components['views.emojipicker.QuickReactions'] = Empty
components['views.emojipicker.Preview'] = Empty
components['views.messages.SenderProfile'] = Empty
components['views.rooms.SlateMessageComposer'] = Empty

export { components }
/* eslint-enable */
